import { types as t } from 'mobx-state-tree';
import { AbstractQuestionWithMultipleOption } from '../abstract-question-multiple-option.store';
import { FileInfo } from '../../Script/abtract-script.store';

export const SingleAnswerQuestion = AbstractQuestionWithMultipleOption.named('SingleAnswerQuestion')
  .props({
    isImageIncluded: t.maybeNull(t.boolean),
    image: t.maybeNull(FileInfo),
    mobileImage: t.maybeNull(FileInfo),
  })
  .actions((self) => ({
    setImageIncluded(isImageIncluded) {
      self.isImageIncluded = isImageIncluded;
    },
    setImage(image: any) {
      self.image = image;
    },
    setMobileImage(image: any) {
      self.mobileImage = image;
    },
  }));
